import React, {useState, useLayoutEffect, useRef} from 'react';

const TRANSITION_MS = 300;

const CollapserThing = ({visible, children}) => {
  const content = useRef(null);
  const [height, setHeight] = useState(visible ? 'auto' : 0);

  useLayoutEffect(() => {
    if (!content.current) return undefined;
    if (visible) {
      // Animate from 0 → measured height, then unlock to 'auto' so the panel
      // grows/shrinks with content (images loading, async data, etc.).
      setHeight(content.current.scrollHeight);
      const timer = setTimeout(() => setHeight('auto'), TRANSITION_MS);
      return () => clearTimeout(timer);
    }
    // Collapsing: lock current height, then animate to 0 on the next frame.
    setHeight(content.current.scrollHeight);
    const raf = requestAnimationFrame(() => setHeight(0));
    return () => cancelAnimationFrame(raf);
  }, [visible]);

  return <div className="transition-all duration-300 ease-in-out overflow-hidden" style={{height}} ref={content}>{children}</div>;
};

export default CollapserThing;
